var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagRussiaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48.2383C37.2548 48.2383 48 37.4931 48 24.2383C48 10.9834 37.2548 0.238281 24 0.238281C10.7452 0.238281 0 10.9834 0 24.2383C0 37.4931 10.7452 48.2383 24 48.2383Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5072 32.5862C47.472 29.9862 48 27.1741 48 24.2384C48 21.3027 47.472 18.4906 46.5072 15.8906H1.49278C0.528094 18.4906 0 21.3027 0 24.2384C0 27.1741 0.528094 29.9862 1.49278 32.5862L24 34.6732L46.5072 32.5862Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9994 48.2382C34.3186 48.2382 43.1156 41.7252 46.5066 32.5859H1.49219C4.88322 41.7252 13.6802 48.2382 23.9994 48.2382Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRussiaIcon);
export default __webpack_public_path__ + "static/media/flag-russia-icon.e086e8251274e7c1ab9d1ac9eb8d6d13.svg";
export { ForwardRef as ReactComponent };